import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankOptionalStand = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankOptionalStand },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldOptions = ['Ground Stand', 'Multi-Purpose Stand'];
  const fieldHasError = error && !dataField.valueTankOptionalStand;

  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
      <Spacer space={4} />
      <RadioGroup
        legend={tankOptionalStand}
        items={radioItems}
        checkedId={dataField.valueTankOptionalStand || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankOptionalStand: value
        })}
        name="tank-optional-stand"
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      <Spacer space={2} />
    </>
  );
};

TankOptionalStand.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankOptionalStand;
